interface ProviderApplicationIdentifiers {
  groupNpi: string;
  individualNpi: string;
  emailAddress: string;
}

const fallbackMessage = 'An error occurred while submitting your application. Please try again.';

export function formatProviderApplicationError(
  error: unknown,
  identifiers: ProviderApplicationIdentifiers
): string {
  const apiMessage = extractApiMessage(error);
  const normalizedMessage = apiMessage.toLowerCase();
  const isConflict = ['already', 'exists', 'duplicate', 'used', 'in use']
    .some(term => normalizedMessage.includes(term));

  if (!isConflict) return apiMessage;

  if (normalizedMessage.includes('email')) {
    return appendDetail(
      apiMessage,
      identifiers.emailAddress,
      `Email address: ${identifiers.emailAddress}. Please use a different email address.`
    );
  }

  if (normalizedMessage.includes('npi')) {
    const isGroupNpi = normalizedMessage.includes('group') || normalizedMessage.includes('clinic');
    const npi = isGroupNpi ? identifiers.groupNpi : identifiers.individualNpi;
    const label = isGroupNpi ? 'Group NPI' : 'Individual NPI';
    return appendDetail(apiMessage, npi, `${label}: ${npi}.`);
  }

  return apiMessage;
}

function extractApiMessage(error: unknown): string {
  if (!error || typeof error !== 'object') return fallbackMessage;

  if ('message' in error && typeof error.message === 'string' && error.message.trim()) {
    return error.message.trim();
  }

  if (
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'message' in error.error &&
    typeof error.error.message === 'string' &&
    error.error.message.trim()
  ) {
    return error.error.message.trim();
  }

  return fallbackMessage;
}

function appendDetail(message: string, value: string, detail: string): string {
  if (!value || message.toLowerCase().includes(value.toLowerCase())) return message;
  const separator = /[.!?]$/.test(message) ? ' ' : '. ';
  return `${message}${separator}${detail}`;
}
